import React from "react";
import ComingSoon from "./ComingSoon";

const Ussd = () => {
  return <ComingSoon />;
};

export default Ussd;
